import axios from 'axios';

let API_BASE_URL =
  process.env.REACT_APP_API_URL1 ||
  "http://localhost:5001";

API_BASE_URL = API_BASE_URL.replace(/\/+$/, "");

if (!API_BASE_URL.endsWith("/api/v1")) {
  API_BASE_URL += "/api/v1";
}

console.log("🔗 FINAL FORGOT PASS BASE:", API_BASE_URL);

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export const requestPasswordReset = (email) =>
  apiClient.post("/auth/forgot-password", { email }).then(r => r.data);

export const resetPassword = (token, newPassword) =>
  apiClient.post("/auth/reset-password", { token, newPassword }).then(r => r.data);

export const changePassword = (currentPassword, newPassword) => {
  const token = localStorage.getItem("authToken");
  return apiClient.post(
    "/auth/change-password",
    { currentPassword, newPassword },
    { headers: { Authorization: `Bearer ${token}` } }
  ).then(r => r.data);
};

export const resendVerification = (email) =>
  apiClient.post("/auth/resend-verification", { email }).then(r => r.data);

export default {
  requestPasswordReset,
  resetPassword,
  changePassword,
  resendVerification,
};
